import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, Input, signal, WritableSignal } from '@angular/core';
import { MessageContentAttachmentMediaTypeEnum } from '@ffd/api-client';
import { AttachmentThumbnailPipe, FileUrlPipe } from '@libs/utils';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { PreviewImageModule, PreviewVideoModule } from '@libs/media-preview';
import { pathParameter, PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { ActivatedRoute } from '@angular/router';
import { Attachment } from './attachment.vm';

@Component({
  selector: 'lib-attachment',
  templateUrl: 'attachment.component.html',
  styleUrls: ['attachment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SvgIconComponent,
    FileUrlPipe,
    PreviewImageModule,
    PreviewVideoModule,
    AttachmentThumbnailPipe,
    PushTagOnClickDirective,
  ],
})
export class AttachmentComponent {
  @Input() public attachment?: Attachment;
  @Input() public preview = true;
  @Input() public size: 'square' | 'normal' | 'auto' | 'support-collab' = 'normal';
  @Input() public set selected(value: boolean) {
    this.selectedSignal.set(value);
  }
  @Input() public set selectedImageIds(value: string[]) {
    this.selectedImageIdsSignal.set(value);
  }
  @Input() public groupSelection = false;
  @Input() public groupSelectionSize = 0;

  public supportCollabThumbnailUrl = 'assets/images/support-collab-video-thumbnail.png';

  public readonly elementRef = inject(ElementRef);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected readonly thumbnailLoaded = signal(false);
  protected readonly selectedImageIdsSignal: WritableSignal<string[]> = signal([]);
  protected readonly selectedSignal = signal(false);
  public readonly patientId = computed(() => this.activatedRoute.snapshot.paramMap.get(pathParameter('patientId')));

  protected readonly MediaType = MessageContentAttachmentMediaTypeEnum;
  public TagEvent = TagEvent;
}
